var GetDefaultValue = function (key) {
    return (this.defaultData) ? this.defaultData[key] : undefined;
}
export default GetDefaultValue;